import { render, staticRenderFns } from "./shixisp.vue?vue&type=template&id=0fe7e983&scoped=true"
import script from "./shixisp.vue?vue&type=script&lang=js"
export * from "./shixisp.vue?vue&type=script&lang=js"
import style0 from "./shixisp.vue?vue&type=style&index=0&id=0fe7e983&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7e983",
  null
  
)

export default component.exports